import { render, staticRenderFns } from "./ComplianceReferenceNumber.vue?vue&type=template&id=dbed126e&scoped=true&"
import script from "./ComplianceReferenceNumber.vue?vue&type=script&lang=js&"
export * from "./ComplianceReferenceNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbed126e",
  null
  
)

export default component.exports